import { TemplateStore } from '../components/App/stores/TemplateStore';
import { AppStore } from '../components/App/stores/AppStore';
import { KurtosysApiStore } from '../components/App/stores/KurtosysApiStore';
import { TranslationStore } from '../components/App/stores/TranslationStore';
import { QueryStore } from '../components/App/stores/QueryStore';
import { Manifest } from './Manifest';
import { DisclaimersStore } from '../components/Disclaimers/stores/DisclaimersStore';
import { AccessibilityStore } from '../components/App/stores/AccessibilityStore';
import { InputStore } from '../components/App/stores/InputsStore';
import { EventBusStore } from '../components/App/stores/EventBusStore';
/* [Component: storesImport] */

export class StoreContext {
	templateStore: TemplateStore;
	appStore: AppStore;
	kurtosysApiStore: KurtosysApiStore;
	translationStore: TranslationStore;
	queryStore: QueryStore;
	disclaimersStore: DisclaimersStore;
	accessibilityStore: AccessibilityStore;
	inputStore: InputStore;
	eventBusStore: EventBusStore;
	/* [Component: storeVariable] */
	constructor(element: HTMLElement, url: string, templateStore: TemplateStore, public manifest: Manifest) {
		this.templateStore = templateStore;
		this.kurtosysApiStore = new KurtosysApiStore(this);
		this.translationStore = new TranslationStore(this);
		this.queryStore = new QueryStore(this);
		this.inputStore = new InputStore(this);
		this.eventBusStore = new EventBusStore(this);
		this.appStore = new AppStore(element, url, this, manifest);
		this.disclaimersStore = new DisclaimersStore(this);
		this.accessibilityStore = new AccessibilityStore(this);
		/* [Component: storeAssignment] */
		this.initialize();
	}
	initialize() {
		this.appStore.initialize();
	}
	reInitialize() {
		this.appStore.reInitialize();
	}
	get providerProps() {
		return {
			appStore: this.appStore,
			kurtosysApiStore: this.kurtosysApiStore,
			translationStore: this.translationStore,
			queryStore: this.queryStore,
			disclaimersStore: this.disclaimersStore,
			accessibilityStore: this.accessibilityStore,
			inputStore: this.inputStore,
			eventBusStore: this.eventBusStore,
			/* [Component: storeProviderProps] */
		};
	}

	// TODO: NEED TO MERGE STORES
	registerStore(key: string, store: any) {

	}
}